export default __webpack_public_path__ + "static/media/line_verticle.bff6d4c3.svg";